import React, { ReactNode } from 'react';
import Styled from 'styled';
import classnames from 'classnames';
import { useQuery } from '@apollo/client/react/hooks';

import LoadingProgress from 'lib/react-router/loading-progress';

import ErrorPage from 'four-nets/errors/error-page';

import defaultStyles from './author-collections.scss';
import CollectionNode from '../../collections/collection-node/collection-node';
import query, {
    AdditionalCollectionsLoaderQuery,
    AdditionalCollectionsLoaderQueryVariables,
} from './author-collections.graphql';
import { FormattedMessage } from 'react-intl';

interface Props {
    styles: typeof defaultStyles;
    slug: string;
    username: string;
    viewerIsAuthor: boolean;
}

const AuthorCollections: React.FC<Props> = props => {
    const { styles, username, slug, viewerIsAuthor } = props;

    const { data, error, loading } = useQuery<
        AdditionalCollectionsLoaderQuery,
        AdditionalCollectionsLoaderQueryVariables
    >(query, {
        variables: {
            first: viewerIsAuthor ? 6 : 12,
            excludeSlug: slug,
            userCollections: username,
        },
    });

    const collections = Array<ReactNode>();
    if (data && data.collections && data.collections.edges) {
        data.collections.edges
            .filter((edge: any) => Boolean(edge && edge.node))
            .forEach((edge: any) => {
                collections.push(<CollectionNode {...edge!.node!} />);
            });
    }

    return (
        <LoadingProgress loading={loading}>
            <ErrorPage error={error}>
                {collections.length > 0 ? (
                    <div
                        className={classnames(styles.wrapper, {
                            [styles.orderUnderCollection]: viewerIsAuthor,
                        })}
                    >
                        {viewerIsAuthor ? (
                            <FormattedMessage id='MY_COLLECTIONS'>
                                {msg => <span className={styles.title}>{msg}</span>}
                            </FormattedMessage>
                        ) : (
                            <FormattedMessage id='MORE_COLLECTIONS_FROM_USER' values={{ username }}>
                                {msg => <span className={styles.title}>{msg}</span>}
                            </FormattedMessage>
                        )}
                        <ul className={styles.collections}>
                            {collections.map((collection, index) => (
                                <li className={styles.collection} key={index}>
                                    {collection}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : null}
            </ErrorPage>
        </LoadingProgress>
    );
};

export default Styled(defaultStyles)(AuthorCollections);
